import { IconText } from '@/shared/ui/icon-text'

import type { FC, ReactNode } from 'react'

export type TypographyContentTitleProps = {
  children: ReactNode
}

export const TypographyContentTitle: FC<TypographyContentTitleProps> = ({ children }) => {
  return (
    <div className="block-content-title">
      <IconText type="paragraph" variant="md" color="secondary">
        {children}
      </IconText>
    </div>
  )
}

TypographyContentTitle.displayName = 'TypographyContentTitle'
